import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-accc00c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = {
  key: 0,
  class: "statistics-list"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "num" }
const _hoisted_9 = { class: "unit" }
const _hoisted_10 = { class: "device-type-list" }
const _hoisted_11 = { class: "device-type-box" }
const _hoisted_12 = { class: "device-status" }
const _hoisted_13 = { class: "status-list" }
const _hoisted_14 = { class: "line-bar" }
const _hoisted_15 = {
  key: 0,
  class: "chart-item"
}
const _hoisted_16 = {
  key: 1,
  class: "chart-item"
}
const _hoisted_17 = { class: "right" }
const _hoisted_18 = { class: "nav" }
const _hoisted_19 = { class: "nav-list" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "notic" }
const _hoisted_23 = ["innerHTML"]

import * as echarts from 'echarts'
import { onMounted, ref, onUnmounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { cloneDeep } from 'lodash'
import { trendCommonConf, trendSeriesCommonConf } from './conf/echarts.conf'
import {
  summarizeDeviceAlarmInfo,
  summarizeDeviceAlarmChart,
  announceQuery,
  summarizeDeviceMsgChart,
  summarizeDeviceLogInfo,
} from '@/api'
import { CODE_ENUM } from '@/common'
import xss from 'xss'

import tab1 from '@/assets/img/home/icon-total.png'
import tab2 from '@/assets/img/home/icon-active.png'
import tab3 from '@/assets/img/home/icon-online.png'
import tab4 from '@/assets/img/home/icon-message.png'

import nav1 from '@/assets/img/home/icon-device.svg'
import nav2 from '@/assets/img/home/icon-location.svg'
import nav3 from '@/assets/img/home/icon-play.svg'
import nav4 from '@/assets/img/home/icon-msg.svg'
import { set } from 'lodash'
import { useEnumsStore } from '@/stores/enums'
import { getLineColor, transformNumber } from '@/utils'
import i18n from '@/i18n'
import { useAuthStore } from '@/stores/auth'
import StatusPieChart from './components/status-pie-chart.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore()

const t = i18n.global.t

const enumsStore = useEnumsStore()

const router = useRouter()

const statistics = ref([
  {
    label: t('HOME.deviceTotal'),
    icon: tab1,
    unit: t('HOME.unit1'),
    number: '',
    key: 'deviceTotal',
    compareKey: 'lastMonthUpDownDeviceTotal',
    compareNumber: '',
  },
  {
    label: t('HOME.sOnline'),
    icon: tab2,
    unit: t('HOME.unit1'),
    number: '',
    key: 'onlineDeviceTotal',
    compareKey: 'lastMonthUpDownOnlineDeviceTotal',
    compareNumber: '',
  },
  {
    label: t('HOME.sOffline'),
    icon: tab3,
    unit: t('HOME.unit1'),
    number: '',
    key: 'offlineDeviceTotal',
    compareKey: 'lastMonthUpDownOfflineDeviceTotal',
    compareNumber: '',
  },
  {
    label: t('HOME.sUnActivated'),
    icon: tab4,
    unit: t('HOME.unit1'),
    number: '',
    key: 'noActiveDeviceTotal',
    compareKey: 'lastMonthUpDownNoActiveDeviceTotal',
    compareNumber: '',
  },
])
const validateAuthCode = (code: string) => {
  return authStore.resources.includes(code)
}

statistics.value = statistics.value.filter((item: any) => {
  return !item.code || validateAuthCode(item.code)
})

const navList = [
  {
    label: t('HOME.nav1'),
    icon: nav1,
    router: '/device/device-list',
    code: '1-1',
  },
  {
    label: t('HOME.nav2'),
    icon: nav2,
    router: '/device/device-location',
    code: '1-2',
  },
  {
    label: t('HOME.nav3'),
    icon: nav3,
    router: '/device/device-trail',
    code: '1-3',
  },
  {
    label: t('HOME.nav4'),
    icon: nav4,
    router: '/warning/warning-message',
    code: '3-2',
  },
]

const authNavList = navList.filter(({ code }: any) => {
  return authStore.resources.includes(code)
})

const toLink = (nav: any) => {
  router.push(nav.router)
}

const pieConf = ref([
  {
    name: t('HOME.deviceTypeMulti'),
    key: 'multiModeDeviceTotal',
  },
  {
    name: t('HOME.deviceTypeSingle'),
    key: 'singleModeDeviceTotal',
  },
  {
    name: 'Lora',
    key: 'loraDeviceTotal',
  },
])

const pieOption = {
  tooltip: {
    trigger: 'item',
  },
  legend: {
    bottom: '0',
    icon: 'circle',
    itemWidth: 10,
    itemHeight: 10,
  },
  series: [
    {
      type: 'pie',
      radius: ['40%', '65%'],
      data: [],
    },
  ],
}

const pieChartRef = ref()

onMounted(async () => {
  if (validateAuthCode('1-1-1')) {
    queryTabInfo()

    queryDeviceAlarmChart()
  }

  queryNotice()

  if (validateAuthCode('4-2-1')) {
    await enumsStore.queryDeviceMsgType()
    transformMsgEventMap()

    queryDeviceMsg()
  }

  window.addEventListener('resize', resizeCharts)
})

const queryTabInfo = async () => {
  const [deviceData, logData]: any = await Promise.all([
    queryDeviceAlarmInfo(),
    queryDeviceAlarmLogInfo(),
  ])

  statusPieConf.value = statusPieConf.value.map((item: any) => {
    const num = deviceData[item.key] || 0
    const otherNum = deviceData.deviceTotal - num

    return {
      ...item,
      percent: deviceData[item.percentKey] || 0,
      num,
      otherNum,
    }
  })

  nextTick(() => {
    pieRefList.value.map((refItem: any) => {
      refItem.init()
    })
  })

  const myChart = echarts.init(pieChartRef.value)
  const pieConfSeries = pieConf.value.map((item: any, index: number) => {
    return {
      ...item,
      value: deviceData[item.key] || 0,
      ...getLineColor(index),
      label: {
        formatter: '{c}',
      },
    }
  })
  const ops = cloneDeep(pieOption)
  set(ops, 'series[0].data', pieConfSeries)
  myChart.setOption(ops)

  const data = Object.assign(deviceData, logData)

  statistics.value = statistics.value.map((item: any) => {
    return {
      ...item,
      number: data[item.key] || '',
      compareNumber: item.compareKey ? data[item.compareKey] : '',
    }
  })
}

const queryDeviceAlarmLogInfo = async () => {
  if (!validateAuthCode('4-2-1')) {
    return {}
  }
  return new Promise(async (resove: any) => {
    const res: any = await summarizeDeviceLogInfo()
    if (res?.code === CODE_ENUM.SUCCESS) {
      resove(res.data || {})
    }
  })
}

const queryDeviceAlarmInfo = async () => {
  if (!validateAuthCode('1-1-1')) {
    return {}
  }
  return new Promise(async (resove: any) => {
    const res: any = await summarizeDeviceAlarmInfo()
    if (res?.code === CODE_ENUM.SUCCESS) {
      resove(res.data || {})
    }
  })
}

const deviceRef = ref()
const chartMap = ref({})
const deviceMap = {
  deviceActiveTotal: t('HOME.deviceActiveTotal'),
  deviceTotal: t('HOME.deviceTotalNumber'),
}
const queryDeviceAlarmChart = async () => {
  const res: any = await summarizeDeviceAlarmChart()
  let xAxis: any = []
  if (res?.code === CODE_ENUM.SUCCESS) {
    const seriesObj = res?.data
    const series = Object.keys(seriesObj).map((key: any, index: number) => {
      const { yaxis, xaxis } = seriesObj[key]
      const name = deviceMap[key]
      xAxis = xaxis
      return {
        name,
        data: yaxis,
        ...getLineColor(index),
        ...cloneDeep(trendSeriesCommonConf),
      }
    })
    const ops = {
      ...cloneDeep(trendCommonConf),
      series,
    }
    set(ops, 'xAxis.data', xAxis)
    const myChart = echarts.init(deviceRef.value)
    myChart.setOption(ops)
    chartMap.value['deviceChartInfo'] = myChart
  }
}

const msgEventMap = ref({})
// 处理事件
const transformMsgEventMap = () => {
  msgEventMap.value = enumsStore.chartMsgEnum.reduce((mo: any, el: any) => {
    const { label, value } = el
    mo[value] = label
    return mo
  }, {})
}

const deviceRef2 = ref()
const queryDeviceMsg = async () => {
  const res: any = await summarizeDeviceMsgChart()
  let xAxis: any = []
  if (res?.code === CODE_ENUM.SUCCESS) {
    const seriesObj = res?.data
    const series = Object.keys(seriesObj).map((key: any, index: number) => {
      const { yaxis, xaxis } = seriesObj[key]
      const name = msgEventMap.value[key]
      xAxis = xaxis
      return {
        name,
        data: yaxis,
        ...getLineColor(index),
        ...cloneDeep(trendSeriesCommonConf),
      }
    })
    const ops = {
      ...cloneDeep(trendCommonConf),
      series,
    }
    set(ops, 'xAxis.data', xAxis)

    const myChart = echarts.init(deviceRef2.value)
    myChart.setOption(ops)
    chartMap.value['alarmChartInfo'] = myChart
  }
}

const noticText = ref('')
const queryNotice = async () => {
  const res: any = await announceQuery()
  if (res?.code === CODE_ENUM.SUCCESS) {
    if (res?.data?.length) {
      noticText.value = xss(res.data[0].announceContent, {
        whiteList: {
          a: ['href', 'title', 'target'],
          p: ['style'],
          b: ['style'],
          h1: ['style'],
          h3: ['style'],
          h5: ['style'],
          h6: ['style'],
          span: ['style'],
        },
        stripIgnoreTag: false,
        stripIgnoreTagBody: ['script'],
      })
    }
  }
}

const resizeCharts = () => {
  Object.keys(chartMap.value).forEach((chartsId: any) => {
    chartMap.value[chartsId]?.resize?.()
  })
}

onUnmounted(() => {
  window.removeEventListener('resize', resizeCharts)
})

const statusPieConf = ref([
  {
    label: t('HOME.sOnline'),
    num: 0,
    percent: 0,
    key: 'onlineDeviceTotal',
    percentKey: 'onlineDeviceRate',
    color: '#548DE3',
  },
  {
    label: t('HOME.sOffline'),
    num: 0,
    percent: 0,
    key: 'offlineDeviceTotal',
    percentKey: 'offlineDeviceRate',
    color: '#E35454',
  },
  {
    label: t('HOME.sUnActivated'),
    num: 0,
    percent: 0,
    key: 'noActiveDeviceTotal',
    percentKey: 'noActiveDeviceRate',
    color: '#9BE354',
  },
])

const pieRefList: any = ref([])
const getPieRef = (el: any, index: number) => {
  if (el) {
    pieRefList.value[index] = el
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (validateAuthCode('1-1-1'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statistics.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "statistics",
                key: index
              }, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: ""
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1),
                  _createElementVNode("p", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(transformNumber)(Number(item.number))), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.unit), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass([{ 'history-visible': item.compareKey }, "history"])
                  }, _toDisplayString(_ctx.$t('HOME.lastMonth')) + "：" + _toDisplayString(item.compareNumber), 3)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('HOME.t1')), 1),
          _createElementVNode("div", {
            class: "device-type-chart-box",
            ref_key: "pieChartRef",
            ref: pieChartRef
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('HOME.t2')), 1),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusPieConf.value, (item, index) => {
              return (_openBlock(), _createBlock(StatusPieChart, {
                key: index,
                data: item,
                ref_for: true,
                ref: (el) => getPieRef(el, index)
              }, null, 8, ["data"]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (validateAuthCode('1-1-1'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('HOME.deviceTrends')), 1),
              _createElementVNode("div", {
                ref_key: "deviceRef",
                ref: deviceRef,
                class: "device"
              }, null, 512)
            ]))
          : _createCommentVNode("", true),
        (validateAuthCode('4-2-1'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('HOME.msgReportTrends')), 1),
              _createElementVNode("div", {
                ref_key: "deviceRef2",
                ref: deviceRef2,
                class: "device"
              }, null, 512)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('HOME.nav')), 1),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authNavList), (nav, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "nav-item",
              onClick: ($event: any) => (toLink(nav)),
              key: index
            }, [
              _createElementVNode("img", {
                src: nav.icon,
                alt: ""
              }, null, 8, _hoisted_21),
              _createElementVNode("span", null, _toDisplayString(nav.label), 1)
            ], 8, _hoisted_20))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('HOME.notice')), 1),
        _createElementVNode("div", {
          class: "content",
          innerHTML: noticText.value
        }, null, 8, _hoisted_23)
      ])
    ])
  ]))
}
}

})